// Ce que font les demandes d'amitié — et rien d'autre.
//
// Ce fichier contenait aussi les BOUTONS : un fabricant de HTML
// (`boutonsAmitie`) et un écouteur posé sur toute la page qui rattrapait les
// clics par leurs attributs `data-ami` (`brancherAmitie`). Il fallait que chaque
// écran écrive le bon attribut ET n'oublie pas de brancher l'écouteur ; l'oubli
// ne se voyait pas — le bouton s'affichait, il ne faisait simplement rien.
//
// Les deux écrans qui s'en servaient — l'annuaire et le profil — sont passés à
// React, où le bouton porte lui-même ce qu'il fait (`react/BoutonsAmitie.jsx`).
// Ces deux fonctions n'avaient plus aucun appelant : elles sont retirées.
//
// Reste ici la seule chose qui compte : ce qu'une action d'amitié PROVOQUE.

import Store, { etatAmitie } from "../store.js";
import { toast, confirmer } from "../ui.js";

export { etatAmitie };

/**
 * Exécute une action d'amitié — le SEUL endroit où elle est écrite.
 *
 * Les règles (qui notifie qui, ce qu'on demande avant de retirer un ami) ne
 * doivent exister qu'à un exemplaire : dupliquées, elles finiraient par diverger
 * en silence.
 *
 * Lève en cas d'échec : c'est à l'appelant de le montrer.
 * @returns {Promise<void>}
 */
export async function agirAmitie(action, uid, nom, ctx) {
  switch (action) {
    case "demander":
      await Store.amis.demander(uid);
      Store.notifs.add(uid, { type: "demande_ami", deId: ctx.moi.uid, deNom: ctx.moi.nom, dePhoto: ctx.moi.photo || "" });
      toast("Demande d'amitié envoyée");
      return;
    case "accepter":
      await Store.amis.accepter(uid);
      Store.notifs.add(uid, { type: "ami_accepte", deId: ctx.moi.uid, deNom: ctx.moi.nom, dePhoto: ctx.moi.photo || "" });
      toast("Vous êtes maintenant amis 🤝");
      return;
    case "refuser":
      await Store.amis.supprimer(uid);
      toast("Demande supprimée");
      return;
    case "annuler":
      if (await confirmer("Annuler la demande ?", `Votre demande d'amitié ${nom ? "à " + nom : ""} sera retirée.`, "Annuler la demande"))
        await Store.amis.supprimer(uid);
      return;
    case "retirer":
      if (await confirmer("Retirer cet ami ?", `${nom || "Ce membre"} ne sera plus dans vos amis.`, "Retirer"))
        await Store.amis.supprimer(uid);
      return;
  }
}
